import React from 'react';
import clsx from 'clsx';
import { withFormsy } from 'formsy-react';
import { alpha, Box, Chip, FormControlLabel, styled, Switch, type BoxProps } from '@mui/material';

import { type FieldProps } from './components/BaseTextField';

type RootProps = BoxProps & { hasLogs?: boolean };

type SwitchFieldProps = Omit<FieldProps<boolean | 'true' | 'false'>, 'startAdornment' | 'endAdornment'>;

const Root = styled(Box)<RootProps>(({ hasLogs, theme }) => ({
	backgroundColor: hasLogs ? alpha(theme.palette.action.disabledBackground, 0.1) : undefined,
	'&:hover': {
		backgroundColor: hasLogs ? alpha(theme.palette.action.disabledBackground, 0.13) : undefined
	}
}));

function SwitchField(props: SwitchFieldProps) {
	const hasLogs = props.logProps?.hasLogs(props.name);
	const logsCounter = props.logProps?.getLogsCounter(props.name);
	const openLogsDialog = () => props.logProps?.openLogsDialog(props.name, props.label);

	function handleChange(event) {
		if (props.beforeChange) props.beforeChange(event.target.checked);
		props.sendChange(event.target.name, event.target.checked);
		if (props.afterChange) props.afterChange(event.target.checked);
	}

	const logsClass = hasLogs ? 'cursor-pointer' : '';
	const logsInputClass = hasLogs ? 'cursor-pointer rounded-r-4 rounded-t-4' : '';

	return (
		<Root
			className={clsx('flex cursor-default justify-between', logsInputClass, props.className)}
			onClick={openLogsDialog}
		>
			<FormControlLabel
				className={logsClass}
				label={props.label}
				control={
					<Switch
						name={props.name}
						className={logsClass}
						checked={props.value === true || props.value === 'true'}
						onChange={handleChange}
					/>
				}
				disabled={!props.isEdit}
				sx={{
					'& > .MuiFormControlLabel-label': {
						color: theme => `${theme.palette.text.primary} !important`
					},
					height: 52,
					marginLeft: theme => theme.spacing(1),
					marginRight: theme => theme.spacing(1)
				}}
			/>
			{hasLogs && (
				<Chip
					className={clsx('mr-6 self-center', logsClass)}
					label={logsCounter}
					size="small"
					color="primary"
				/>
			)}
		</Root>
	);
}

export default React.memo(withFormsy(SwitchField));
